import React from 'react';
import {inject} from 'mobx-react';
import CreatableSelect from 'react-select/lib/Creatable';
import 'react-select/dist/react-select.css';
import classNames from 'classnames';


@inject('providerStore')
export default class MultiSelectWrapper extends React.Component {

  state = {value: []};

  componentWillMount = () => {
    this.setState({
      value: this.props.value,
      options: this.props.elements
    })
  };

  componentWillReceiveProps = newProps => {
    this.setState({
      value: newProps.value,
      options: newProps.elements,
      errors: newProps.errors
    })
  };


  handleChange = data => {
    this.props.handleChange({[this.props.name]: data});
  };

  getValue = () => {
    let res = '';

    this.state.value.forEach(el => {
      res = el.label + ',' + res
    });
    return res;
  };


  clearValue = (e) => {
    this.props.handleRemoveValue(e.target.id)
  }


  render() {
    console.log('state multi', this.state);

    return (
      <div className={classNames('multiselect propvided-workshops', {hasError: this.state.errors})}

      >
        {this.state.value && this.state.value.map((el, i) => (
          <div className="provided-workshop" key={`${el.label} ${i}`}>
            <span className="number">
                {i + 1}
            </span>
            <span className="label">{el.label}</span>
            <button className="clear-workshop" onClick={this.clearValue} id={el.label}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20">
                <path fillRule="evenodd" d="M10 0c5.53 0 10 4.47 10 10s-4.47 10-10 10S0 15.53 0 10 4.47 0 10 0m3.59 5L10 8.59 6.41 5 5 6.41 8.59 10 5 13.59 6.41 15 10 11.41 13.59 15 15 13.59 11.41 10 15 6.41 13.59 5z" opacity=".341"/>
              </svg>
            </button>
          </div>
        ))}
        <CreatableSelect
          className="select-control"
          allowCreate={true}
          multi={true}
          placeholder={this.props.placeholder}
          name={this.props.placeholder}
          value={this.props.value}
          options={this.state.options}
          onChange={this.handleChange}
        />

        {this.state.errors &&
        <span className="error">{this.state.errors}</span>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/create_provider/providerWorkshops.jsx